import { render, staticRenderFns } from "./FormTabHeader.vue?vue&type=template&id=0384b7f5&scoped=true"
import script from "./FormTabHeader.vue?vue&type=script&lang=js"
export * from "./FormTabHeader.vue?vue&type=script&lang=js"
import style0 from "./FormTabHeader.vue?vue&type=style&index=0&id=0384b7f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0384b7f5",
  null
  
)

export default component.exports